export default function Overlay() {

  const buttonStyle = {
    backgroundColor: '#FFB50B',
    color: 'black',
    border: 'none',
    cursor: 'pointer',
    padding: '15px 20px',
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: '16px',
  };

  function handleClick(e){
    e.preventDefault();
    window.open('https://itreebute.com/dashboard', "_blank");
  }
  return (
    <>
      {/* <h2><a href="https://itreebute.com" target="_blank">itreebute</a></h2> */}
      <div className="container">
        {/* <h3>Save CO2 </h3> */}
        <button onClick={handleClick} style={buttonStyle}>JETZT BEITRETEN</button>
      </div>
    </>
  )
}
